export const getMapBoundsForFindCars = (
  map,
  maps,
  taggedCarsSaverGlobalState,
  carData,
  allCarData,
  isValidLocation,
  setNotAvailableCars,
  findCars,
  getMapBoundsForAllCars,
  setOpenPopupNotAvailableCars,
  setAll
) => {
  let taggedCars = JSON.parse(JSON.stringify(taggedCarsSaverGlobalState));
  taggedCars.map((item) => {
    let findTaggedInCarData = carData.find((item1) => item1.CarNumber === item);
    if (!findTaggedInCarData) {
      let findTaggedInAllCarData = allCarData.find(
        (allCarDataItem) => allCarDataItem.Car.CarNumber === item
      );
      if (findTaggedInAllCarData) carData.push(findTaggedInAllCarData);
    }
  });

  let available = false;
  let notAvailableCarsTemp = [];
  let availableCarsTemp = [];
  taggedCars.map((item, i) => {
    carData.map((item1) => {
      if (item1.Car.CarNumber === item) {
        if (isValidLocation(item1.Car.Latitude, item1.Car.Longitude)) {
          available = true;
        }
      }
      return null;
    });

    if (!available) {
      notAvailableCarsTemp = [...notAvailableCarsTemp, item];
      taggedCars.splice(i, 1);
    } else availableCarsTemp = [...availableCarsTemp, item];
    available = false;
    return null;
  });
  if (notAvailableCarsTemp.length > 0) {
    if (availableCarsTemp.length > 0) {
      const bounds = new maps.LatLngBounds();
      carData.map((place) => {
        let findTaged = taggedCars.find((item) => {
          return place.Car.CarNumber === item;
        });
        if (findTaged) {
          bounds.extend(
            new maps.LatLng(place.Car?.Latitude, place.Car?.Longitude)
          );
        }
        return null;
      });

      setNotAvailableCars([...notAvailableCarsTemp]);
      setOpenPopupNotAvailableCars(true);

      return bounds;
    }
    setNotAvailableCars([...notAvailableCarsTemp]);
    setOpenPopupNotAvailableCars(true);

    return getMapBoundsForAllCars(
      map,
      maps,
      allCarData,
      isValidLocation,
      setAll
    );
  } else {
    const bounds = new maps.LatLngBounds();

    carData.map((place) => {
      let findTaged = taggedCars.find((item) => {
        return place.Car.CarNumber === item;
      });

      if (findTaged) {
        bounds.extend(
          new maps.LatLng(place.Car?.Latitude, place.Car?.Longitude)
        );
      }
      return null;
    });
    findCars.set(false);
    return bounds;
  }
};
